/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type timerModalV3_QueryVariables = {
    personId?: string | null | undefined;
    taskId?: string | null | undefined;
};
export type timerModalV3_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"timerModalV3_viewer">;
    } | null;
};
export type timerModalV3_Query = {
    readonly response: timerModalV3_QueryResponse;
    readonly variables: timerModalV3_QueryVariables;
};



/*
query timerModalV3_Query(
  $personId: ID
  $taskId: ID
) {
  viewer {
    actualPersonId
    component(name: "timer_modal_v3")
    ...timerModalV3_viewer_1m92W2
    id
  }
}

fragment DeprecatedProjectIndicatorJS_project on ProjectType {
  name
  companyProjectId
  customProjectId
  projectColor
}

fragment ProjectDropdown_projects on ProjectTypeEdge {
  node {
    id
    name
    projectColor
    companyProjectId
    customProjectId
    status
    ...DeprecatedProjectIndicatorJS_project
    manualProgressOnProjectEnabled
    manualProgressOnPhasesEnabled
    manualProgressOnTasksEnabled
  }
}

fragment timerModalV3_viewer_1m92W2 on Viewer {
  id
  harvestUser
  language
  actualPersonId
  timerStartDate
  timerEndDate
  excludeFromCompanyLockedPeriod
  submitLockedDateYear
  submitLockedDateMonth
  submitLockedDateDay
  startDate
  endDate
  createdAt
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  sunday
  task(id: $taskId) {
    id
    companyTaskId
    jiraId
    name
    timeLeft
    billable
    parentTaskId
    estimateForecastMinutes
    totalMinutesRegistered
    startDay
    startMonth
    startYear
    deadlineDay
    deadlineMonth
    deadlineYear
    project {
      id
      companyProjectId
      status
      name
      billable
      projectColor
      projectStartYear
      projectStartMonth
      projectStartDay
      projectEndYear
      projectEndMonth
      projectEndDay
      harvestProject {
        id
      }
      unit4Project {
        id
        activitiesEnabled
      }
      projectPerson(personId: $personId) {
        role {
          id
          name
        }
        id
      }
    }
    role {
      id
      name
    }
  }
  timerTask {
    id
    companyTaskId
    startYear
    startMonth
    startDay
    deadlineDay
    deadlineMonth
    deadlineYear
    name
    timeLeft
    billable
    estimateForecastMinutes
    totalMinutesRegistered
    role {
      id
    }
    assignedPersons {
      id
    }
    statusColumnV2 {
      category
      id
    }
    project {
      id
      companyProjectId
      status
      name
      billable
      projectColor
      projectStartYear
      projectStartMonth
      projectStartDay
      projectEndYear
      projectEndMonth
      projectEndDay
      harvestProject {
        id
      }
      projectPerson(personId: $personId) {
        role {
          id
          name
        }
        id
      }
    }
  }
  availableFeatureFlags {
    key
    id
  }
  company {
    id
    bambooHREnabled
    hiBobEnabled
    harvestEnabled
    characterLimit
    lockedPeriodYear
    lockedPeriodMonth
    lockedPeriodDay
    roles(includeDisabled: false) {
      edges {
        node {
          id
          name
        }
      }
    }
    modules {
      moduleType
      id
    }
    idleTimes(first: 10000) {
      edges {
        node {
          id
          name
          isInternalTime
          disabled
        }
      }
    }
    person(id: $personId) {
      id
      role {
        id
      }
    }
  }
  projects(first: 10000, excludeDoneOrHalted: true, excludeReadOnly: true) {
    edges {
      ...ProjectDropdown_projects
      node {
        id
        name
        companyProjectId
        isProgramRevenueLocked
        programBudgetType
        billable
        projectStartYear
        projectStartMonth
        projectStartDay
        projectEndYear
        projectEndMonth
        projectEndDay
        manualProgressOnProjectEnabled
        manualProgressOnPhasesEnabled
        manualProgressOnTasksEnabled
        status
        projectColor
        harvestProject {
          id
        }
        projectPerson(personId: $personId) {
          role {
            id
            name
          }
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId",
    "type": "ID"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "timer_modal_v3"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"timer_modal_v3\")"
},
v3 = {
  "kind": "Variable",
  "name": "personId",
  "variableName": "personId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecastMinutes",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalMinutesRegistered",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v26 = [
  (v4/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v28 = [
  (v4/*: any*/),
  (v6/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": [
    (v3/*: any*/)
  ],
  "concreteType": "ProjectPerson",
  "kind": "LinkedField",
  "name": "projectPerson",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v26/*: any*/),
  "storageKey": null
},
v32 = {
  "kind": "Literal",
  "name": "first",
  "value": 10000
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "timerModalV3_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "taskId",
                "variableName": "taskId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "timerModalV3_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "timerModalV3_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "harvestUser",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timerStartDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timerEndDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "excludeFromCompanyLockedPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tuesday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wednesday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thursday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "friday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "saturday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sunday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "taskId"
              }
            ],
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "jiraId",
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentTaskId",
                "storageKey": null
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Unit4ProjectType",
                    "kind": "LinkedField",
                    "name": "unit4Project",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "activitiesEnabled",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v30/*: any*/)
                ],
                "storageKey": null
              },
              (v29/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "timerTask",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v13/*: any*/),
              (v12/*: any*/),
              (v11/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "assignedPersons",
                "plural": true,
                "selections": (v26/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StatusColumnV2",
                "kind": "LinkedField",
                "name": "statusColumnV2",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "category",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v27/*: any*/),
                  (v30/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bambooHREnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hiBobEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "harvestEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "characterLimit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedPeriodDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "includeDisabled",
                    "value": false
                  }
                ],
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v28/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "roles(includeDisabled:false)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v32/*: any*/)
                ],
                "concreteType": "IdleTimeTypeConnection",
                "kind": "LinkedField",
                "name": "idleTimes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IdleTimeTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IdleTime",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isInternalTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "disabled",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "idleTimes(first:10000)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "personId"
                  }
                ],
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v31/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "excludeDoneOrHalted",
                "value": true
              },
              {
                "kind": "Literal",
                "name": "excludeReadOnly",
                "value": true
              },
              (v32/*: any*/)
            ],
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v19/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customProjectId",
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "manualProgressOnProjectEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "manualProgressOnPhasesEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "manualProgressOnTasksEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isProgramRevenueLocked",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "programBudgetType",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v27/*: any*/),
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projects(excludeDoneOrHalted:true,excludeReadOnly:true,first:10000)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "timerModalV3_Query",
    "operationKind": "query",
    "text": "query timerModalV3_Query(\n  $personId: ID\n  $taskId: ID\n) {\n  viewer {\n    actualPersonId\n    component(name: \"timer_modal_v3\")\n    ...timerModalV3_viewer_1m92W2\n    id\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment ProjectDropdown_projects on ProjectTypeEdge {\n  node {\n    id\n    name\n    projectColor\n    companyProjectId\n    customProjectId\n    status\n    ...DeprecatedProjectIndicatorJS_project\n    manualProgressOnProjectEnabled\n    manualProgressOnPhasesEnabled\n    manualProgressOnTasksEnabled\n  }\n}\n\nfragment timerModalV3_viewer_1m92W2 on Viewer {\n  id\n  harvestUser\n  language\n  actualPersonId\n  timerStartDate\n  timerEndDate\n  excludeFromCompanyLockedPeriod\n  submitLockedDateYear\n  submitLockedDateMonth\n  submitLockedDateDay\n  startDate\n  endDate\n  createdAt\n  monday\n  tuesday\n  wednesday\n  thursday\n  friday\n  saturday\n  sunday\n  task(id: $taskId) {\n    id\n    companyTaskId\n    jiraId\n    name\n    timeLeft\n    billable\n    parentTaskId\n    estimateForecastMinutes\n    totalMinutesRegistered\n    startDay\n    startMonth\n    startYear\n    deadlineDay\n    deadlineMonth\n    deadlineYear\n    project {\n      id\n      companyProjectId\n      status\n      name\n      billable\n      projectColor\n      projectStartYear\n      projectStartMonth\n      projectStartDay\n      projectEndYear\n      projectEndMonth\n      projectEndDay\n      harvestProject {\n        id\n      }\n      unit4Project {\n        id\n        activitiesEnabled\n      }\n      projectPerson(personId: $personId) {\n        role {\n          id\n          name\n        }\n        id\n      }\n    }\n    role {\n      id\n      name\n    }\n  }\n  timerTask {\n    id\n    companyTaskId\n    startYear\n    startMonth\n    startDay\n    deadlineDay\n    deadlineMonth\n    deadlineYear\n    name\n    timeLeft\n    billable\n    estimateForecastMinutes\n    totalMinutesRegistered\n    role {\n      id\n    }\n    assignedPersons {\n      id\n    }\n    statusColumnV2 {\n      category\n      id\n    }\n    project {\n      id\n      companyProjectId\n      status\n      name\n      billable\n      projectColor\n      projectStartYear\n      projectStartMonth\n      projectStartDay\n      projectEndYear\n      projectEndMonth\n      projectEndDay\n      harvestProject {\n        id\n      }\n      projectPerson(personId: $personId) {\n        role {\n          id\n          name\n        }\n        id\n      }\n    }\n  }\n  availableFeatureFlags {\n    key\n    id\n  }\n  company {\n    id\n    bambooHREnabled\n    hiBobEnabled\n    harvestEnabled\n    characterLimit\n    lockedPeriodYear\n    lockedPeriodMonth\n    lockedPeriodDay\n    roles(includeDisabled: false) {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    modules {\n      moduleType\n      id\n    }\n    idleTimes(first: 10000) {\n      edges {\n        node {\n          id\n          name\n          isInternalTime\n          disabled\n        }\n      }\n    }\n    person(id: $personId) {\n      id\n      role {\n        id\n      }\n    }\n  }\n  projects(first: 10000, excludeDoneOrHalted: true, excludeReadOnly: true) {\n    edges {\n      ...ProjectDropdown_projects\n      node {\n        id\n        name\n        companyProjectId\n        isProgramRevenueLocked\n        programBudgetType\n        billable\n        projectStartYear\n        projectStartMonth\n        projectStartDay\n        projectEndYear\n        projectEndMonth\n        projectEndDay\n        manualProgressOnProjectEnabled\n        manualProgressOnPhasesEnabled\n        manualProgressOnTasksEnabled\n        status\n        projectColor\n        harvestProject {\n          id\n        }\n        projectPerson(personId: $personId) {\n          role {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '43e6b21b605a7de52451df510071785e';
export default node;
